import { ReactNode, useId } from "react";

interface HelpPanelProps {
	title: ReactNode;
	/** Links or buttons at the right of the header, such as "View all". */
	actions?: ReactNode;
	className?: string;
	children: ReactNode;
}

/** A white panel with a labelled header, as Engage's SoftPanel. */
function HelpPanel({
	title,
	actions,
	className,
	children,
}: Readonly<HelpPanelProps>) {
	const titleId = useId();
	return (
		<section
			className={className ? `help-panel ${className}` : "help-panel"}
			aria-labelledby={titleId}
		>
			<div className="help-panel__head">
				<h2 id={titleId} className="help-panel__title">
					{title}
				</h2>
				{actions}
			</div>
			<div className="help-panel__body">{children}</div>
		</section>
	);
}

export default HelpPanel;
